import axios from 'axios';
import Qs from 'qs'
import 'babel-polyfill'

// axios.defaults.timeout = 5000;
axios.defaults.baseURL = '';


//http request 拦截器
axios.interceptors.request.use(
    config => {
        if(config.method === 'get') {
            //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
            config.paramsSerializer = function (params) {
                return Qs.stringify(params, {arrayFormat: 'repeat'})
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


//http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)

export function fetch_v2(url, params = {}) {
    return new Promise((resolve, reject) => {
        params['version'] = 'v4'
        let headers = { 'Content-Type': 'application/json' }
        axios.get(url, {
            params: params,
            headers:headers
        })
          .then(response => {
              if (response.data.code !== 0) {
                  reject(response)
              }else{
                  resolve(response.data.result);
              }
          }, err => {
              reject(err.response)
          })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post_v2(url, data = {}, deep = false, notShowError = false) {
    return new Promise((resolve, reject) => {
        if (deep) {
            data = Object.assign(data, { version: 'v4' })
        } else {
            data = { data, version: 'v4' }
        }
        let headers = { 'Content-Type': 'application/json' }
        axios.post(url, JSON.stringify(data), {
            headers
        }).then(response => {
            if (response.data.code !== 0) {
                reject(response)
            }else{
                resolve(response.data.result);
            }
        }, err => {
            reject(err.response)
        })
    })
}



// WEBPACK FOOTER //
// ./src/config/http.js